<template>
  <div>
    <v-card color="grey lighten-1" flat rounded="xl">
      <v-container class="px-6">
        <CustomerSummary />
        <DeliverySummary />
        <InvoiceSummary v-if="callCenterStore.isInvoiceShow" />
        <OrderSummary />
      </v-container>
    </v-card>
    <v-row align="center" class="my-9">
      <v-col md="6">
        <v-btn class="text-capitalize" plain x-large block rounded @click="backStep()"
          >Geri Git
        </v-btn>
      </v-col>
      <v-col md="6">
        <v-btn
          color="secondary"
          class="text-capitalize"
          depressed
          rounded
          x-large
          block
          :loading="callCenterStore.isDisabledOrder"
          @click="saveOrder()"
        >
          {{ isEdit ? "Güncelle" : "Kaydet" }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";

// Components
import CustomerSummary from "./Customer.vue";
import DeliverySummary from "./Delivery.vue";
import InvoiceSummary from "./Invoice.vue";
import OrderSummary from "./Order.vue";

// Utils
import { postData } from "@utils";
import { useRouter } from "@core/utils";

import { useToast } from "vue-toastification/composition";

// Store
import { useCallCenterStore } from "@/stores/callCenter";

// Icon
import { mdiCalendar, mdiClock } from "@mdi/js";

export default {
  components: {
    CustomerSummary,
    DeliverySummary,
    InvoiceSummary,
    OrderSummary,
  },
  setup() {
    // Store
    const callCenterStore = useCallCenterStore();
    const toast = useToast();
    const { route, router } = useRouter();
    const isEdit = ref(false);

    const backStep = () => {
      if (callCenterStore.isInvoiceShow) {
        callCenterStore.decrease();
      } else {
        callCenterStore.callCenterStep = 3;
      }
    };

    const saveOrder = () => {
      callCenterStore.isDisabledOrder = true;
      const data = {
        method: "callCenterCreateOrder",
        ...callCenterStore.saveData,
      };
      if (isEdit.value) {
        data.id = route.value.params.item.id;
      }

      postData(data)
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error === 1) {
            throw new Error(response.msg);
          }
          toast.success(response.msg);
          router.push({ name: "dashboard-call-center" });
        })
        .catch((e) => {
          toast.error(e.message, {
            position: "bottom-center",
          });
        })
        .finally(() => {
          // Call Center Store Eski Haline Çekme
          callCenterStore.isDisabledOrder = false;
        });
    };

    onMounted(() => {
      if (route.value.params.item) {
        isEdit.value = true;
      }
    });

    return {
      callCenterStore,
      backStep,
      saveOrder,
      isEdit,
      icons: {
        mdiCalendar,
        mdiClock,
      },
    };
  },
};
</script>
